import type { IconData } from '@stacksjs/iconify-core'

export const css3Simple: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20.772 3.364A1 1 0 0 0 20 3H6a1 1 0 0 0 0 2h12.786l-.78 4H5a1 1 0 0 0 0 2h12.615l-1.163 5.955l-6.323 1.997l-5.41-1.7l.203-1.064a1 1 0 0 0-1.964-.375l-.37 1.94a1 1 0 0 0 .682 1.141l6.56 2.06a1 1 0 0 0 .601 0l7.19-2.27a1 1 0 0 0 .68-.763l2.68-13.73a1 1 0 0 0-.209-.827\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default css3Simple
